import FilterSection from 'components/FilterPopover/FilterSection';
import Checkbox from 'components/inputs/Checkbox';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import { SubmittalCategory } from 'records/SubmittalCategory';
import { SubmittalQuery } from 'records/SubmittalQuery';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props {
  submittalQuery: SubmittalQuery;
  updateSubmittalQuery: (nextSubQuery: SubmittalQuery) => void;
}

const CategoriesFilterSection: React.FC<Props> = (props: Props) => {
  const { submittalQuery, updateSubmittalQuery } = props;
  const { state: appState } = useContext(AppStoreContext);
  const { submittals } = appState;
  const { translate } = useTranslator(['submittalsPage']);

  const allCategories = submittals
    .valueSeq()
    .map((s) => s.category)
    .toSet()
    .sortBy((d) => d.display.toLocaleLowerCase());

  /* Handlers */
  function onCheckboxChange(nextCategory: SubmittalCategory) {
    const nextSubQuery = submittalQuery.update('categories', (categories) => {
      const category = categories.find((c) => c.kind === nextCategory.kind);

      return category
        ? categories.delete(category)
        : categories.add(nextCategory);
    });

    updateSubmittalQuery(nextSubQuery);
  }
  /* */

  const appliedFilters = submittalQuery.categories
    .map((s) => s.display)
    .sortBy((d) => d.toLocaleLowerCase())
    .toArray();

  return (
    <FilterSection
      label={translate('submittalsPage:categories.title')}
      appliedFilters={appliedFilters}
      disabled={allCategories.size === 0}
    >
      <div className="h100 oa px4 py3">
        {allCategories.map((subCategory): React.ReactNode => {
          const { kind } = subCategory;
          const categoryType: `${string}:${string}` =
            `submittalsPage:categories.${kind}` as `${string}:${string}`;
          return (
            <div
              key={kind}
              className="row mb3 cursor-pointer disable-select"
              onClick={() => onCheckboxChange(subCategory)}
            >
              <Checkbox
                id={`punch-filter-popover-status-checkbox-${kind}`}
                onChange={() => onCheckboxChange(subCategory)}
                checked={submittalQuery.categories.has(subCategory)}
              />
              <div className="ml2 truncate">{translate(categoryType)}</div>
            </div>
          );
        })}
      </div>
    </FilterSection>
  );
};

export default CategoriesFilterSection;
